<template>
  <div>
    <div
      v-for="(calculation, index) in calculations"
      :key="index"
      class="row relative-position"
    >
      <QSeparator v-if="index" class="separator q-ma-none" color="primary" />
      <div
        :class="[
          'q-pa-md col-4 bg-primary-dark row items-center',
          { 'inset-shadow': !index }
        ]"
      >
        <QSpinnerDots color="white" v-if="loading" size="16px" />
        <span
          v-else
          :class="[
            'text-label text-white',
            { 'text-weight-bold': calculation.bold }
          ]"
        >
          {{ calculation.label }}
          <SAIInformationPopup
            v-if="calculation.information"
            icon-color="primary"
          >
            <p>{{ calculation.information }}</p>
          </SAIInformationPopup>
        </span>
      </div>
      <div
        :class="[
          'q-pa-md col-4 row justify-end items-center',
          {
            'text-weight-bold': calculation.bold,
            'inset-shadow': !index,
            'bg-primary-semi-dark text-white': noSacrificeActive,
            'bg-white': sacrificeActive
          }
        ]"
      >
        <QSpinnerDots
          :color="noSacrificeActive ? 'white' : 'grey-8'"
          v-if="loading"
          size="16px"
        />
        <span
          v-if="calculation.negative && !loading"
          :class="[
            'text-negative text-weight-medium q-mr-xs',
            { 'text-title': noSacrificeActive }
          ]"
        >
          &ndash;
        </span>
        <span
          v-if="!loading"
          :class="{
            'text-weight-bold': calculation.bold,
            'text-title': sacrificeActive
          }"
        >
          {{
            Math.abs(calculation.sacrifice)
              | frequency('monthly', frequency)
              | currency
          }}
        </span>
      </div>
      <div
        :class="[
          'q-pa-md col-4 row justify-end items-center shadow',
          {
            'inset-shadow': !index,
            'bg-primary-semi-dark text-white': sacrificeActive,
            'bg-white': noSacrificeActive
          }
        ]"
      >
        <QSpinnerDots
          :color="sacrificeActive ? 'white' : 'grey-8'"
          v-if="loading"
          size="16px"
        />
        <span
          v-else-if="calculation.negative"
          :class="[
            'text-negative text-weight-medium q-mr-xs',
            { 'text-title': noSacrificeActive }
          ]"
        >
          &ndash;
        </span>
        <span
          v-if="!loading"
          :class="{
            'text-weight-bold': calculation.bold,
            'text-title': noSacrificeActive
          }"
        >
          {{
            calculation.noSacrifice | frequency('monthly', frequency) | currency
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { SAIInformationPopup } from 'ecx.saigon.ui.common';
import { QSeparator, QSpinnerDots } from 'quasar';

export default {
  name: 'BudgetCalculationsSummary',
  props: {
    loading: Boolean,
    sacrificeActive: Boolean,
    noSacrificeActive: Boolean,
    calculations: {
      type: Array,
      default: () => []
    },
    frequency: {
      type: String,
      required: true
    }
  },
  components: {
    QSeparator,
    SAIInformationPopup,
    QSpinnerDots
  }
};
</script>

<style lang="sass" scoped>
.separator
  opacity: 0.3
  position: absolute
  z-index: 1

.inset-shadow
  box-shadow: inset 0 7px 9px -7px rgba(0,0,0,0.14)!important
.shadow
  box-shadow: -5px 4px 9px 2px rgba(0,0,0,0.14)
</style>
